import { render, staticRenderFns } from "./deleteAdminServ.vue?vue&type=template&id=907c32ba&scoped=true"
import script from "./deleteAdminServ.vue?vue&type=script&lang=js"
export * from "./deleteAdminServ.vue?vue&type=script&lang=js"
import style0 from "./deleteAdminServ.vue?vue&type=style&index=0&id=907c32ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907c32ba",
  null
  
)

export default component.exports